import { Todo } from '../domain/todo/todo'
import { Location } from '../domain/location/location'

export class State {
  isLoading = false
  todos: Todo[] = []
  locations: Location[] = []
}
